import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { NAV_LINKS, CAFE } from "@/data/content";

export default function Footer() {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer-section" className="relative overflow-hidden border-t border-[var(--line)] bg-cafe pt-24">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <div className="grid grid-cols-1 gap-14 pb-20 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="mb-6 font-body text-xs uppercase tracking-[0.35em] text-accent">Visit us</p>
            <a
              href={CAFE.mapUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-map-link"
              className="group inline-flex items-start gap-3 font-serif-c text-2xl italic text-[var(--text)]/80 link-underline"
            >
              <MapPin size={22} className="mt-1 shrink-0 text-accent" />
              {CAFE.address}
            </a>

            <div className="mt-10 max-w-md">
              <p className="mb-4 font-body text-xs uppercase tracking-[0.2em] text-[var(--text)]/40">Opening hours</p>
              <ul data-testid="footer-hours" className="divide-y divide-[var(--line)]">
                {CAFE.hours.map((h) => (
                  <li key={h.day} className="flex items-center justify-between py-2 font-body text-sm">
                    <span className="text-[var(--text)]/60">{h.day}</span>
                    <span className="text-[var(--text)]/90">{h.time}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-3 font-body text-xs italic text-[var(--text)]/40">{CAFE.hoursNote}</p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="mb-6 font-body text-xs uppercase tracking-[0.2em] text-[var(--text)]/40">Explore</p>
            <ul className="flex flex-col gap-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    onClick={() => go(l.href)}
                    className="font-serif-c text-xl text-[var(--text)]/80 link-underline"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="mb-6 font-body text-xs uppercase tracking-[0.2em] text-[var(--text)]/40">Social</p>
            <ul className="flex flex-col gap-3 font-serif-c text-xl text-[var(--text)]/80">
              <li><a href="https://www.facebook.com/share/1BoQ6NDHJt/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="link-underline" data-testid="footer-facebook">Facebook</a></li>
            </ul>
          </div>
        </div>
      </div>

      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="select-none whitespace-nowrap px-6 pb-6 font-display text-[22vw] leading-none tracking-tighter text-[var(--text)]/[0.06] md:px-10"
      >
        Mehretina
      </motion.h2>

      <div className="border-t border-[var(--line)] py-6">
        <div className="mx-auto flex max-w-[1500px] flex-col items-start justify-between gap-2 px-6 font-body text-xs uppercase tracking-[0.2em] text-[var(--text)]/40 md:flex-row md:items-center md:px-10">
          <span>© {new Date().getFullYear()} Mehretina Cafe</span>
          <span>Buna · Culture · Community</span>
        </div>
      </div>
    </footer>
  );
}
